import { render, staticRenderFns } from "./goodWaterfall.vue?vue&type=template&id=c8c190d4&scoped=true"
import script from "./goodWaterfall.vue?vue&type=script&lang=js"
export * from "./goodWaterfall.vue?vue&type=script&lang=js"
import style0 from "./goodWaterfall.vue?vue&type=style&index=0&id=c8c190d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c190d4",
  null
  
)

export default component.exports